import React, { Component } from 'react';
import { Platform } from 'react-native';
import {
  EntypoIcon,
  EvilIconsIcon,
  FeatherIcon,
  FontAwesomeIcon,
  FoundationIcon,
  IoniconsIcon,
  MaterialCommunityIconsIcon,
  MaterialIconsIcon,
  OcticonsIcon,
  SimpleLineIconsIcon,
  ZocialIcon,
} from '../modules';
import FontUtils from '../utils/FontUtils';

class Icon extends Component {

  constructor (props) {
    super(props);

    this.state = {};
  }

  componentWillMount () {
    if (Platform.OS !== 'web') {
      return;
    }

    const {type} = this.props;
    switch (type) {
      case 'Entypo': {
        FontUtils.importEntypo();
      }
      case 'EvilIcons': {
        FontUtils.importEvilIcons();
      }
      case 'Feather': {
        FontUtils.importFeather();
      }
      case 'FontAwesome': {
        FontUtils.importFontAwesome();
      }
      case 'Foundation': {
        FontUtils.importFoundation();
      }
      case 'Ionicons': {
        FontUtils.importIonicons();
      }
      case 'MaterialCommunityIcons': {
        FontUtils.importMaterialCommunityIcons();
      }
      case 'MaterialIcons': {
        FontUtils.importMaterialIcons();
      }
      case 'Octicons': {
        FontUtils.importOcticons();
      }
      case 'SimpleLineIcons': {
        FontUtils.importSimpleLineIcons();
      }
      case 'Zocial': {
        FontUtils.importZocial();
      }
    }
  }

  componentDidMount () {
  }

  componentWillUnmount () {
  }

  componentWillReceiveProps (nextProps) {
  }

  render () {
    const {type} = this.props;
    switch (type) {
      case 'Entypo': {
        return (
          <EntypoIcon
            {...this.props} />
        );
      }
      case 'EvilIcons': {
        return (
          <EvilIconsIcon
            {...this.props} />
        );
      }
      case 'Feather': {
        return (
          <FeatherIcon
            {...this.props} />
        );
      }
      case 'FontAwesome': {
        return (
          <FontAwesomeIcon
            {...this.props} />
        );
      }
      case 'Foundation': {
        return (
          <FoundationIcon
            {...this.props}/>
        );
      }
      case 'Ionicons': {
        return (
          <IoniconsIcon
            {...this.props} />
        );
      }
      case 'MaterialCommunityIcons': {
        return (
          <MaterialCommunityIconsIcon
            {...this.props} />
        );
      }
      case 'MaterialIcons': {
        return (
          <MaterialIconsIcon
            {...this.props}/>
        );
      }
      case 'Octicons': {
        return (
          <OcticonsIcon
            {...this.props}/>
        );
      }
      case 'SimpleLineIcons': {
        return (
          <SimpleLineIconsIcon
            {...this.props}/>
        );
      }
      case 'Zocial': {
        return (
          <ZocialIcon
            {...this.props} />
        );
      }
      default: {
        return null;
      }
    }
  }
}

export default Icon;



// WEBPACK FOOTER //
// ./src/common/Icon.js